import type { UploadConnectionType } from "./types";
import { mapUploadConnectionType } from "./uploadConnectionTypeMap";

type NetworkInformationLike = {
  type?: string;
};

declare global {
  interface Navigator {
    connection?: NetworkInformationLike;
    mozConnection?: NetworkInformationLike;
    webkitConnection?: NetworkInformationLike;
  }
}

/**
 * Chromium-only Network Information API, plus `navigator.onLine` which even
 * Safari can use to report offline. Returns `undefined` when neither signal
 * can name a warehouse value — do not invent wifi/cellular on Firefox/Safari.
 */
export const getUploadConnectionType = (): Promise<
  UploadConnectionType | undefined
> => {
  if (typeof navigator === "undefined") {
    return Promise.resolve(undefined);
  }
  try {
    const connection =
      navigator.connection ??
      navigator.mozConnection ??
      navigator.webkitConnection;
    return Promise.resolve(
      mapUploadConnectionType({
        type: connection?.type,
        isOnline: navigator.onLine,
      }),
    );
  } catch {
    return Promise.resolve(undefined);
  }
};
